var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-logo-view"},[(_vm.computedImageSrc)?_c('img',{key:_vm.computedImageSrc,attrs:{"src":_vm.computedImageSrc,"data-requested-src":_vm.computedImageSrc},on:{"error":_vm.handleLogoError}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }